import { baseApi } from './baseApi'

type NotificationPreference = {
  email: boolean
  sms: boolean
}

type NotificationPreferences = Record<string, NotificationPreference>

type PhysicianGroupProfile = {
  notificationPreferences: NotificationPreferences
}

export const physicianGroupProfileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPhysicianGroupProfile: builder.query<PhysicianGroupProfile, void>({
      query: () => ({ url: '/physician-group/profile' }),
      providesTags: ['User'],
    }),
    updatePhysicianGroupProfile: builder.mutation<
      PhysicianGroupProfile,
      { notificationPreferences: NotificationPreferences }
    >({
      query: (body) => ({
        url: '/physician-group/profile',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['User'],
    }),
  }),
})

export const {
  useGetPhysicianGroupProfileQuery,
  useUpdatePhysicianGroupProfileMutation,
} = physicianGroupProfileApi
